import { handleApiError } from '../core/apiError';
import axiosInstance from '../core/axiosInstance';

/**
 * Sends a request to the server to create a new database backup.
 * 
 * This function sends a `GET` request to the `/backup/create` endpoint 
 * to create a new database backup from the server. The 
 * server's response, which includes the database backup in base64Encoding, will be returned.
 * It uses the default Axios instance with pre-configured headers and base URL.
 * 
 * @function
 * @returns {Promise<Object>} - A promise that resolves to the server's response data.
 * @throws {Error} - Throws an error if the request fails.
 * 
 */
export const getGstDetails = async () => {
    try {
        const response = await axiosInstance.get('/setting/gst');
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error; // Rethrow to handle it in the component
    }
};


export const updateGstDetails = async (setting_id, payload) => {
    try {
        const response = await axiosInstance.put(`/setting/gst/${setting_id}`, payload);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error; // Rethrow to handle it in the component
    }
};

/**
 * Sends a request to the server to create a new database backup.
 * 
 * This function sends a `GET` request to the `/backup/create` endpoint 
 * to create a new database backup from the server. The 
 * server's response, which includes the database backup in base64Encoding, will be returned.
 * It uses the default Axios instance with pre-configured headers and base URL.
 * 
 * @function
 * @returns {Promise<Object>} - A promise that resolves to the server's response data.
 * @throws {Error} - Throws an error if the request fails.
 * 
 */
export const createDatabaseBackup = async () => {
    try {
        const response = await axiosInstance.get('/backup/create');
        downloadDatabaseBackup(response.data.data);
        return response.data;
    } catch (error) {
        handleApiError(error);
        throw error; // Rethrow to handle it in the component
    }
};

/**
 * 
 * This function generates a downloadable file for the database backup.
 * the data is in JSON format, so firstly base64 data is decoded
 * and then a blob file with a downloadable link is created.
  * 
 * @function
 * @returns {Promise<Object>} - A downloadable datase backup file with .sql format.
 * @throws {Error} - Throws an error if the request fails.
 * 
 */
export const downloadDatabaseBackup = (data) => {
    if (data && data.fileContentBase64 && data.fileName) {
        // Decode the base64 content
        const byteCharacters = atob(data.fileContentBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob and download link
        const blob = new Blob([byteArray], {
            type: "application/octet-stream",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = data.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        throw new Error("Invalid file data received");
    }
}